module.exports = __webpack_public_path__ + "cc.572471bd816c580d8d74.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cc.svg
// module chunks = styles